import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Drawer, Grid, Typography, Chip, makeStyles, Button, Divider } from "@material-ui/core";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { SearchSelect, SubmitButton } from "../../../../../";
import { Debug } from "../../../../Forms/Debug";
import _ from "lodash";
var useStyles = makeStyles(function (theme) {
  return {
    drawerContainer: {
      padding: "24px",
      width: "380px"
    },
    chip: {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px"
    },
    title: {
      margin: "16px 0 8px 0"
    },
    card: {
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px 0"
    },
    cardText: {
      marginTop: "8px"
    },
    cardIconText: {
      marginTop: "8px",
      display: "flex",
      alignItems: "center"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "24px"
    },
    mr30: {
      marginRight: "30px"
    },
    icon: {
      margin: "8px"
    },
    mt8: {
      marginTop: "8px"
    },
    divider: {
      margin: "4px 0"
    },
    containerDelete: {
      height: "100vh",
      display: "flex",
      alignItems: "center"
    },
    alignCenter: {
      width: "100%",
      textAlign: "center"
    },
    iconDelete: {
      fontSize: "128px",
      textAlign: "center",
      width: "100%"
    },
    iconUser: {
      fontSize: "80px",
      textAlign: "center",
      width: "100%"
    },
    iconActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
});

var CampusSingleDrawerUser = function CampusSingleDrawerUser(props) {
  var _useState = useState("view"),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  var classes = useStyles();

  var toggleDrawer = function toggleDrawer() {
    setType("view");
    props.toggleDrawer();
  };

  var renderDrawerContent = function renderDrawerContent() {
    var content;

    switch (type) {
      case "view":
        content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5",
          align: "center"
        }, props.user && props.user.name)), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(AccountCircleIcon, {
          className: classes.iconUser
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.iconActions
        }, /*#__PURE__*/React.createElement(EditIcon, {
          style: {
            color: "#ffe082"
          },
          className: classes.icon,
          onClick: function onClick() {
            setType("edit");
          }
        }), /*#__PURE__*/React.createElement(DeleteIcon, {
          color: "secondary",
          className: classes.icon,
          onClick: function onClick() {
            setType("delete");
          }
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.groups || "Groups" : "Groups"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, props.user && props.user.groups.map(function (group) {
          return /*#__PURE__*/React.createElement(Chip, {
            key: "campus-drawer-user-group-".concat(group._id),
            label: group.name,
            className: classes.chip
          });
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.allergies || "Allergies" : "Allergies"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.user && props.user.allergies)), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.comments || "Comments" : "Comments"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.user && props.user.comments)), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.parents || "Parents" : "Parents"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, props.user && props.user.parents.map(function (parent) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.card,
            key: "campus-drawer-user-parent-".concat(parent._id)
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            className: classes.cardText
          }, parent.name), parent.phone && /*#__PURE__*/React.createElement(Typography, {
            variant: "body2",
            className: classes.cardIconText
          }, /*#__PURE__*/React.createElement(PhoneIcon, {
            fontSize: "small"
          }), parent.phone), parent.email && /*#__PURE__*/React.createElement(Typography, {
            variant: "body2",
            className: classes.cardIconText
          }, /*#__PURE__*/React.createElement(EmailIcon, {
            fontSize: "small"
          }), parent.email));
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.extraResponsibles || "Authorized Responsibles" : "Authorized Responsibles"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, props.user && props.user.extraResponsibles && props.user.extraResponsibles.map(function (extraResponsible) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.card,
            key: "campus-drawer-user-extra-responsible-".concat(extraResponsible._id)
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            className: classes.cardText
          }, extraResponsible.name), extraResponsible.phone && /*#__PURE__*/React.createElement(Typography, {
            variant: "body2",
            className: classes.cardIconText
          }, /*#__PURE__*/React.createElement(PhoneIcon, {
            fontSize: "small"
          }), extraResponsible.phone));
        })));
        break;

      case "edit":
        var initialValues = {
          name: "",
          groups: [],
          allergies: "",
          comments: "",
          parents: [],
          extraResponsibles: []
        };
        var userSchema = Yup.object().shape({
          name: Yup.string().required("Campo obligatorio"),
          groups: Yup.array(),
          allergies: Yup.string(),
          comments: Yup.string(),
          parents: Yup.array(),
          extraResponsibles: Yup.array().of(Yup.object().shape({
            name: Yup.string().required(),
            // email: Yup.string().email(),
            phone: Yup.string().required()
          }))
        });

        var user = _objectSpread(_objectSpread({}, props.user), {}, {
          groups: props.user.groups.map(function (group) {
            return group.key;
          }),
          parents: props.user.parents.map(function (parent) {
            return _objectSpread(_objectSpread({}, parent), {}, {
              editable: false
            });
          }),
          extraResponsibles: props.user.extraResponsibles.map(function (extraResponsible) {
            return _objectSpread(_objectSpread({}, extraResponsible), {}, {
              editable: false
            });
          })
        });

        content = /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Formik, {
          initialValues: user || initialValues,
          validationSchema: userSchema,
          onSubmit: function onSubmit(values) {
            toggleDrawer();

            if (values.name !== user.name || values.comments !== user.comments || values.allergies !== user.allergies || values.status !== user.status) {
              values.childChanged = true;
            } else {
              values.childChanged = false;
            }

            if (_(values.extraResponsibles).xorWith(user.extraResponsibles, _.isEqual).isEmpty()) {
              values.extraResponsiblesChanged = false;
              delete values.extraResponsibles;
            } else {
              values.extraResponsiblesChanged = true;
              values.extraResponsibles = _.difference(values.extraResponsibles, user.extraResponsibles);
            }

            if (props.isGroupsEditable) {
              values.groups = {
                addTo: _.difference(values.groups, user.groups).map(function (group) {
                  return {
                    key: group,
                    name: props.groups.find(function (_group) {
                      return _group._id === group;
                    }).name
                  };
                }),
                removeFrom: _.difference(user.groups, values.groups)
              };
            } else {
              values.groups = {
                addTo: [],
                removeFrom: []
              };
            }

            console.log("values to send", values);
            props.handleEditUser(values);
          },
          render: function render(_ref) {
            var values = _ref.values,
                isValid = _ref.isValid,
                isSubmitting = _ref.isSubmitting;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
              name: "name",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), props.isGroupsEditable ? /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              name: "groups",
              key: "groups",
              component: SearchSelect,
              label: props.translation ? props.translation.selects ? props.translation.selects.groups || "Groups" : "Groups" : "Groups",
              options: props.groups ? props.groups.map(function (group) {
                return {
                  label: group.name,
                  value: group._id
                };
              }) : [],
              variant: "outlined",
              isMulti: true
            })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.title
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "h6"
            }, props.translation ? props.translation.groups || "Groups" : "Groups"), /*#__PURE__*/React.createElement(Divider, {
              className: classes.divider
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, props.user && props.user.groups.map(function (group) {
              return /*#__PURE__*/React.createElement(Chip, {
                key: "campus-drawer-user-group-".concat(group._id),
                label: group.name,
                className: classes.chip
              });
            }))), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.allergies || "Allergies" : "Allergies" : "Allergies",
              name: "allergies",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.comments || "Comments" : "Comments" : "Comments",
              name: "comments",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.title
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "h6"
            }, props.translation ? props.translation.parents || "Parents" : "Parents"), /*#__PURE__*/React.createElement(Divider, {
              className: classes.divider
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, props.user && props.user.parents.map(function (parent) {
              return /*#__PURE__*/React.createElement("div", {
                className: classes.card,
                key: "campus-drawer-user-parent-".concat(parent._id)
              }, /*#__PURE__*/React.createElement(Typography, {
                variant: "body1",
                className: classes.cardText
              }, parent.name), parent.phone && /*#__PURE__*/React.createElement(Typography, {
                variant: "body2",
                className: classes.cardIconText
              }, /*#__PURE__*/React.createElement(PhoneIcon, {
                fontSize: "small"
              }), parent.phone), parent.email && /*#__PURE__*/React.createElement(Typography, {
                variant: "body2",
                className: classes.cardIconText
              }, /*#__PURE__*/React.createElement(EmailIcon, {
                fontSize: "small"
              }), parent.email));
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              md: 12
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "body1"
            }, props.translation ? props.translation.extraResponsibles || "Authorized Responsibles" : "Authorized Responsibles"), /*#__PURE__*/React.createElement(FieldArray, {
              name: "extraResponsibles",
              render: function render(_ref2) {
                var insert = _ref2.insert,
                    remove = _ref2.remove,
                    push = _ref2.push;
                return values.extraResponsibles.length > 0 ? values.extraResponsibles.map(function (field, index, arr) {
                  return /*#__PURE__*/React.createElement(Grid, {
                    container: true,
                    alignItems: "center",
                    spacing: 2
                  }, /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    md: 9,
                    key: index
                  }, /*#__PURE__*/React.createElement(Field, {
                    name: "extraResponsibles[".concat(index, "].name"),
                    key: "extraResponsibles[".concat(index, "].name"),
                    label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
                    component: TextField,
                    margin: "normal",
                    fullWidth: true,
                    variant: "outlined",
                    disabled: !values.extraResponsibles[index].editable
                  }), /*#__PURE__*/React.createElement(Field, {
                    name: "extraResponsibles[".concat(index, "].phone"),
                    key: "extraResponsibles[".concat(index, "].phone"),
                    label: props.translation ? props.translation.inputs ? props.translation.inputs.phone || "Phone" : "Phone" : "Phone",
                    component: TextField,
                    margin: "normal",
                    fullWidth: true,
                    variant: "outlined",
                    disabled: !values.extraResponsibles[index].editable
                  })), /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 2
                  }, /*#__PURE__*/React.createElement(Button, {
                    key: "delete",
                    className: classes.button,
                    disabled: !values.extraResponsibles[index].editable,
                    type: "button",
                    color: "secondary",
                    variant: "outlined",
                    onClick: function onClick() {
                      return values.extraResponsibles[index].editable && remove(index);
                    }
                  }, "-"), arr.length - 1 === index && /*#__PURE__*/React.createElement(Button, {
                    key: "add",
                    type: "button",
                    className: classes.mt8,
                    size: "small",
                    color: "primary",
                    variant: "outlined",
                    onClick: function onClick() {
                      return push({
                        name: "",
                        phone: "",
                        email: "",
                        editable: true
                      });
                    }
                  }, "+")), arr.length > 1 && arr.length - 1 !== index && /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12
                  }, /*#__PURE__*/React.createElement(Divider, {
                    className: classes.divider
                  })));
                }) : /*#__PURE__*/React.createElement(Button, {
                  key: "add",
                  type: "button",
                  className: classes.mr30,
                  size: "small",
                  color: "primary",
                  variant: "outlined",
                  onClick: function onClick() {
                    return push({
                      name: "",
                      phone: "",
                      email: "",
                      editable: true
                    });
                  }
                }, "+");
              }
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true,
              className: classes.actions
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: function onClick() {
                setType("view");
              }
            }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.buttons ? props.translation.buttons.edit || "Edit" : "Edit" : "Edit")));
          }
        }));
        break;

      case "delete":
        content = /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.containerDelete,
          alignItems: "center",
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(HighlightOffIcon, {
          color: "secondary",
          className: classes.iconDelete
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "h6",
          className: classes.alignCenter
        }, props.translation ? props.translation.texts ? props.translation.texts.delete_user ? "".concat(props.translation.texts.delete_user.title, "  ").concat(props.user.name) || "Delete user" : "Delete user" : "Delete user" : "Delete user"), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: classes.alignCenter
        }, props.translation ? props.translation.texts ? props.translation.texts.delete_user ? props.translation.texts.delete_user.text ? props.translation.texts.delete_user.text || "Do you want to delete?" : "Do you want to delete?" : "Do you want to delete?" : "Do you want to delete?" : "Do you want to delete?")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          variant: "contained",
          color: "default",
          onClick: function onClick() {
            setType("view");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          variant: "contained",
          color: "secondary",
          onClick: function onClick() {
            toggleDrawer();
            props.handleDeleteUser(props.user.key);
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons["delete"] || "Delete" : "Delete" : "Delete")));
        break;

      default:
        content = "";
        break;
    }

    return content;
  };

  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: props.open,
    onClose: toggleDrawer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.drawerContainer
  }, renderDrawerContent()));
};

export { CampusSingleDrawerUser };